// src/pages/TaxReturn.tsx

import React from 'react';
import { TaxFormProvider } from '@/components/TaxFormWizard/TaxFormContext';
import { TaxFormWizard } from '@/components/TaxFormWizard';

const TaxReturn = () => {
  return (
    <TaxFormProvider>
      <TaxFormWizard />
    </TaxFormProvider>
  );
};

export default TaxReturn;
